import { render } from "./WishlistComponent.vue?vue&type=template&id=2597e308&scoped=true"
import script from "./WishlistComponent.vue?vue&type=script&lang=js"
export * from "./WishlistComponent.vue?vue&type=script&lang=js"

import "./WishlistComponent.vue?vue&type=style&index=0&id=2597e308&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2597e308"]])

export default __exports__